import { Component } from '@angular/core';

import { CoreBuildingBlockControlBaseComponent } from '../../shared/building-block-control-base.component';
import { CoreBuildingBlock } from '../../shared/building-block.decorator';

/**
 * Building block to display readonly information
 */
@CoreBuildingBlock('info-row')
@Component({
  selector: 'cu-info-row',
  templateUrl: './info-row.component.html'
})
export class InfoRowComponent extends CoreBuildingBlockControlBaseComponent {
  /**
   * if there's content field
   */
  public get showContent(): boolean {
    return !this.field.config.content && this.field.data.value !== null;
  }
}
